import OnboardingName from './OnboardingName'

export default OnboardingName
